
export /**
 * Displays compilation errors, or info about successful compilation
 * @param successfullyCompiledUrmProgramExists {boolean} has compilation ever been successful
 * @param compilationErrors {UrmProgramCompilingError[]} errors at last compilation
 * @returns {JSX.Element}
 * @constructor
 */
function UrmProgramCompilationInfoComponent({compilationErrors,
                                                successfullyCompiledUrmProgramExists}) {
    return(
        <div className="urm-program-compilation-info-container">
            {/* compilation errors (or message about successful compilation) */}

            {compilationErrors !== undefined
                ? ( // errors exists
                    compilationErrors.map((error, index) => (
                        <InfoItem key={index} error={error} />
                    ))
                ) : ( // no errors
                    successfullyCompiledUrmProgramExists && (
                        <InfoItem compiledSuccessfully={true} />
                    )
                )
            }
        </div>
    );

    /**
     *
     * @param error {UrmProgramCompilingError}
     * @param compiledSuccessfully {boolean}
     * @returns {JSX.Element}
     * @constructor
     */
    function InfoItem({error, compiledSuccessfully}) {
        if(compiledSuccessfully){
            return(
                <div className="urm-program-compilation-info-item compilation-success">
                    Compiled successfully!
                </div>
            );
        }

        return (
            <div className="urm-program-compilation-info-item compilation-error">
                {(error.lineIndex !== -1) && (
                    <b>line {error.lineIndex + 1}: </b>
                )}
                {error.description}
            </div>
        )
    }
}
